export enum CatalogMode {
  Create = "create",
  Edit = "edit",
  Details = "details",
  Explorer = "explorer",
  Review = "review",
}
